import { memo } from 'react'

import PublishedGame, { TEST_ID } from './PublishedGame'

const PublishedGameComponent = memo(PublishedGame)

export { TEST_ID }

export default PublishedGameComponent
